import { HelpBanner } from '@/components';
import { HelpItem } from '@/components/HelpBanner';
import TrackingPageLayout from '@/components/Layout/TrackingPageLayout';
import { LINK } from '@/constants';
import Blacklisting from '@/pages/TrackingPage/components/Sections/Blacklisting';
import EstimatedDeliveryDate from '@/pages/TrackingPage/components/Sections/EstimatedDeliveryDate';
import TrackingPageEditor from '@/pages/TrackingPage/components/Sections/TrackingPageEditor';
import { TrackingPageContainerStyled } from '@/pages/TrackingPage/styled';
import { tokenSelector } from '@/redux/features/auth.slice';
import { ViewIcon } from '@shopify/polaris-icons';
import { useSelector } from 'react-redux';
import LayoutMediaCard from '@/pages/Dashboard/components/LayoutMediaCard';
import LanguageSection from './components/Sections/Language';
import useTrackingPageUrl from '@/hooks/useTrackingPageUrl';

const customHelpItems: HelpItem[] = [
  { id: '1', label: "Tracking page isn't showing", showBullet: true },
  { id: '2', label: 'Customize tracking page', showBullet: true },
  { id: '3', label: 'Get help with setup', showBullet: true },
  { id: '4', label: 'Request a new feature', showBullet: true },
];

const TrackingPage = () => {
  const { shop } = useSelector(tokenSelector);
  const { proxyPath } = useTrackingPageUrl();

  return (
    <TrackingPageLayout
      isFixed
      title="Tracking Page"
      secondaryActions={[
        {
          content: 'Preview',
          icon: ViewIcon,
          url: LINK.CUSTOMER_SHOP(shop, proxyPath),
        },
      ]}
    >
      <HelpBanner id="505ed922-d384-4e98-b4be-6af3b611593f" title="We're here to help" helpItems={customHelpItems} />
      <TrackingPageContainerStyled>
        <TrackingPageEditor />
        <EstimatedDeliveryDate />
        <Blacklisting />
        <LanguageSection />
      </TrackingPageContainerStyled>
      <LayoutMediaCard />
    </TrackingPageLayout>
  );
};

export default TrackingPage;
